<div class="container rightSideBar">
  <mat-card class="rightSideBarCard" appearance="raised">
    <mat-card-header>
      <strong>Do you need support?</strong>
      <div class="spacer"></div>
      <button (click)="closeBar()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider />
    <mat-card-content class="cardContent">
      @if (loadingContacts() | isFalse) {
        @if (governanceCoordinators$ | async; as governanceCoordinators) {
          <div>
            <div class="titleSupport">
              <strong>Your Governance Contact</strong>
            </div>
            @for (item of governanceCoordinators; track item; let i = $index) {
              <div>
                @if (numberOfItems < governanceCoordinators.length && i === 3) {
                  <div class="showMoreLess hoverable" (click)="numberOfItems = governanceCoordinators.length">show more...</div>
                }
                @if (i < numberOfItems) {
                  <div class="container-Support">
                    <div class="supportPhoto">
                      @if (item && item.picture) {
                        <img class="picture" [src]="item.picture" alt="Support" />
                      }
                      <mat-icon class="" [ngStyle]="getColor(item.presence)" matTooltip="{{ item.presence }}">{{
                        getPresenceIcon(item.presence)
                      }}</mat-icon>
                    </div>
                    <div class="supportData">
                      <div>
                        <label
                          ><strong>{{ item.displayName }}</strong></label
                        >
                      </div>
                      <div>
                        <label>{{ item.jobTitle }}</label>
                      </div>
                      <div class=" ">
                        <mat-icon (click)="sendEmail(item.mail, item.displayName)" matTooltip="Send an email"> email </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="sendChatMessage(item.mail)"
                          matTooltip="Send a message via Microsoft Teams"
                        >
                          question_answer
                        </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="scheduleMeeting(item.mail)"
                          matTooltip="Schedule meeting via Microsoft Teams"
                        >
                          calendar_today
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                }
                @if (governanceCoordinators.length > 3 && i === governanceCoordinators.length - 1 && numberOfItems > 3) {
                  <div class="showMoreLess hoverable" (click)="numberOfItems = 3">show less...</div>
                }
              </div>
            }
          </div>
        }
        @if (riskManagers$ | async; as riskManagers) {
          <div>
            <div class="titleSupport"><strong>Your ORM Contact</strong></div>
            @for (item of riskManagers; track item; let i = $index) {
              <div>
                @if (numberOfItemsL < riskManagers.length && i === 3) {
                  <div class="showMoreLess hoverable" (click)="numberOfItemsL = riskManagers.length">show more...</div>
                }
                @if (i < numberOfItemsL) {
                  <div class="container-Support">
                    <div class="supportPhoto">
                      <img class="picture" [src]="item.picture" alt="Risk Managers" />
                      <mat-icon class="" [ngStyle]="getColor(item.presence)" matTooltip="{{ item.presence }}">{{
                        getPresenceIcon(item.presence)
                      }}</mat-icon>
                    </div>
                    <div class="supportData">
                      <div>
                        <label
                          ><strong>{{ item.displayName }}</strong></label
                        >
                      </div>
                      <div>
                        <label>{{ item.jobTitle }}</label>
                      </div>
                      <div class=" ">
                        <mat-icon (click)="sendEmail(item.mail, item.displayName)" matTooltip="Send an email">email </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="sendChatMessage(item.mail)"
                          matTooltip="Send a message via Microsoft Teams"
                        >
                          question_answer
                        </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="scheduleMeeting(item.mail)"
                          matTooltip="Schedule meeting via Microsoft Teams"
                        >
                          calendar_today
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                }
                @if (riskManagers.length > 3 && i === riskManagers.length - 1 && numberOfItemsL > 3) {
                  <div class="showMoreLess hoverable" (click)="numberOfItemsL = 3">show less...</div>
                }
              </div>
            }
          </div>
        }
        <!-- your compliance contact-->
        @if (complianceContacts$ | async; as compliances) {
          <div>
            <div class="titleSupport">
              <strong>Your Compliance Contact</strong>
            </div>
            @for (item of compliances; track item; let i = $index) {
              <div>
                @if (i < numberOfItemsL) {
                  <div class="container-Support">
                    <div class="supportPhoto">
                      <img class="picture" [src]="item.picture" alt="Compliance" />
                      <mat-icon class="" [ngStyle]="getColor(item.presence)" matTooltip="{{ item.presence }}">{{
                        getPresenceIcon(item.presence)
                      }}</mat-icon>
                    </div>
                    <div class="supportData">
                      <div>
                        <label
                          ><strong>{{ item.displayName }}</strong></label
                        >
                      </div>
                      <div>
                        <label>{{ item.jobTitle }}</label>
                      </div>
                      <div class=" ">
                        <mat-icon (click)="sendEmail(item.mail, item.displayName)" matTooltip="Send an email">email </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="sendChatMessage(item.mail)"
                          matTooltip="Send a message via Microsoft Teams"
                        >
                          question_answer
                        </mat-icon>
                        <mat-icon
                          [matTooltipPosition]="'above'"
                          (click)="scheduleMeeting(item.mail)"
                          matTooltip="Schedule meeting via Microsoft Teams"
                        >
                          calendar_today
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (noContactsAvailable$ | async) {
          <div>
            <div class="no-contacts-message">
              <div class=""><strong>No support contacts available</strong></div>
            </div>
          </div>
        }
      } @else {
        <div>
          <div>
            <div *skeleton="true; height: '25px'; width: '170px'; margin: '0 0 0 27%'"></div>
          </div>
          @for (num of [1, 2, 3]; track num) {
            <div class="container-Support">
              <div class="supportPhoto">
                <div *skeleton="true; height: '50px'; width: '50px'; borderRadius: '50%'; margin: '10px 10px'"></div>
              </div>
              <div class="supportData">
                <div *skeleton="true; height: '23px'; width: '170px'; repeat: 3; margin: '2px 0'"></div>
              </div>
            </div>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
